const item = [
    {
      category: ['BCM'],
      id: 0,
      name: "Business Continuity Management",
      description: "Business Contuinity Management (BCM) is a framework for building organizational resilience" +
                   "with the capability for an effective response that safeguards the interests of its key stakeholders,"+
                   "reputation,brand and value-creating activities",
      button : ["CCM","ERM"]             
    },
    {
      category: [ 'ERM'],
      id: 1,
      name: "Enterprise Risk Management",
      description: "Enterprise Risk Management (ERM) is the process of planning organizing,leading,and controlling the activities"+
                   "of an organization in order to minimize the effects of risk on an organization's capita; and earnings",
      button :["CRS","CDA","CCS","CRS"]
    },
    {
      category: ['CM'],
      id: 2,
      name: "Compliance Management",
      description: "Compliance management is the process by which managers,plan,organize,control,and lead activities"+
                   "that ensure compliance with laws and standards",
      button :["CCX","IR","CCA"]             
    }
  ]

  export default item ;
